var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDollar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 .667a1 1 0 0 1 1 1v.666h.667A4.333 4.333 0 0 1 16 6.667a1 1 0 1 1-2 0 2.333 2.333 0 0 0-2.333-2.334H11V9h.667a4.333 4.333 0 0 1 0 8.667H11v.666a1 1 0 1 1-2 0v-.666h-.667A4.333 4.333 0 0 1 4 13.333a1 1 0 1 1 2 0 2.333 2.333 0 0 0 2.333 2.334H9V11h-.667a4.333 4.333 0 0 1 0-8.667H9v-.666a1 1 0 0 1 1-1M9 4.333h-.667a2.333 2.333 0 0 0 0 4.667H9zM11 11v4.667h.667a2.333 2.333 0 1 0 0-4.667z",
  clipRule: "evenodd"
})));
SvgDollar.displayName = "SvgDollar";
export { SvgDollar as ReactComponent };
export default SvgDollar;